// extracted by mini-css-extract-plugin
export var bodySections = "_d5-8";
export var gray = "_d5-7";
export var green = "_d5-4";
export var iconContainer = "_d5-9";
export var iconWidgetContainer = "_d5-1";
export var phoneIcon = "_d5-2";
export var red = "_d5-5";
export var statusDot = "_d5-3";
export var widgetContainer = "_d5-0";
export var yellow = "_d5-6";